





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Activity, actionTypes, sortOrderTypes } from '@/Activity'
import { TokenUser } from '@/TokenUser'
import * as utils from '@/utils';
import ActivityListComponent from '@/components/ActivityListComponent.vue';
import { IPaginationResult } from '@/PaginationResult'
import GenericDropdown from '@/components/GenericDropdown.vue';
import * as utils_auth from '@/utils_auth';
import { globalUC } from '../UserCache';

@Component({
  name: 'ActivityFeedComponent',
  components: { ActivityListComponent, GenericDropdown }
})
export default class ActivityFeedComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public flowAddress: string = null;
  public activities: Activity[] = null
  public paginationResult: IPaginationResult = null
  public filters: actionTypes[] = []
  public filterOptions: Array<{ text: string, value: actionTypes, disabled: boolean }> = [
    { text: 'Listed', value: actionTypes.Listed, disabled: false },
    { text: 'Delisted', value: actionTypes.Delisted, disabled: false },
    { text: 'Sold', value: actionTypes.Sold, disabled: false },
    { text: 'Bought', value: actionTypes.Bought, disabled: false },
    { text: 'Pack', value: actionTypes.OpenedPack, disabled: false },
    { text: 'Received Gift', value: actionTypes.ReceivedGift, disabled: false },
    { text: 'Sent Gift', value: actionTypes.SendGift, disabled: false },
    { text: 'Reward', value: actionTypes.ReceivedReward, disabled: false },
    { text: 'Auction Sold', value: actionTypes.AuctionSold, disabled: false },
    { text: 'Auction Bought', value: actionTypes.AuctionPurchased, disabled: false },
    { text: 'Traded In', value: actionTypes.TradedInForTicket, disabled: false },
    { text: 'Made Offer', value: actionTypes.OfferMade, disabled: false },
    { text: 'Accepted Offer', value: actionTypes.OfferAccepted, disabled: false },
    { text: 'Canceled Offer', value: actionTypes.OfferCanceled, disabled: false },
    { text: 'Burned', value: actionTypes.Burned, disabled: false },
    { text: 'Locked', value: actionTypes.Locked, disabled: false },
    { text: 'Unlocked', value: actionTypes.Unlocked, disabled: false },
  ]
  public gotCSV: boolean = false

  // UI and filter options
  public sortOrders: Array<{ label: string, sort: string }> = [
    { label: 'Sort recent first', sort: 'Date_DESC' },
    { label: 'Sort oldest first', sort: 'Date_ASC' },
  ]
  public sortOrder: { label: string, sort: string } = this.sortOrders[0]

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public async onChangedSort(sortOrder: { label: string, sort: string }) {
    this.sortOrder = sortOrder
    this.pageNumberToLoadNext = 1
    await this.fetchData()
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  public async setFlowAddress(flowAddress: string, forceRefetch: boolean) {
    if (this.$store.state.devmode) console.log(`ActivityFeedComponent.setFlowAddress(${flowAddress}, ${forceRefetch}) while this.flowAddress===${this.flowAddress}`)
    if (forceRefetch || flowAddress !== this.flowAddress) {
      this.flowAddress = flowAddress
      this.pageNumberToLoadNext = 1
      this.activities = null
      this.paginationResult = null
      await this.fetchData()
    }
  }

  @Watch('filters')
  public async onChangedFilters() {
    this.pageNumberToLoadNext = 1
    this.activities = []
    this.paginationResult = null
    await this.fetchData()
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);
  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  private async getCSV() {
    if (!this.user) {
      utils.toast(this, 'Error', 'You must be logged in with a verified LiveToken account to request a CSV.')
      return
    }

    let url: string = utils.getURLprefix() + `/api/topshot/emailActivityCSV/`
    url += this.flowAddress

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url) {
        if (this.$store.state.devmode) console.log(`ActivityFeed.getCSV() aborting cuz we're already doing it`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one

        utils.toast(this, 'Success', `We emailed the CSV file to your email at ${user.email}.`)
        this.gotCSV = true
      }

    } catch (error) {
      utils.toast(this, 'Error', 'Could not request CSV file')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

  }

  private async fetchData(calledByInfiniteHandlerOrTimer?: boolean): Promise<number> {
    const header: Activity = new Activity(null)
    header.momentID = 0
    header.date = new Date()

    if (!this.flowAddress) return 0
    let url: string = utils.getURLprefix() + `/api/topshot/activities/`;
    url += this.flowAddress
    url += `?page=${this.pageNumberToLoadNext}`;
    url += `&sortOrder=${this.sortOrder.sort}`;
    url += `&filters=${this.filters.join(',')}`;

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`ActivityFeed.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up the activities
      let newRawItems: Activity[] = response.data.activities
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new Activity(po));
        if (this.pageNumberToLoadNext === 1) this.activities = [ header ].concat(newRawItems);
        else this.activities = this.activities.concat(newRawItems)

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }
    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    if (this.$store.state.devmode) utils.toast(this, 'DEBUGGING', `Loaded ${this.activities.length} moments}`)
  }
}
